import { Route } from '@billow/easy-route'

export default Route('/plans', 'plans', () => import('@/views/subscription/Plans'))